import photo1 from "../images/blockstream.png"
import photo2 from "../images/coinbase.png"
import photo3 from "../images/dfinity_community.png"



export default function Partners() {
    return (
        <div className="bg-background">
            <div className="mx-auto py-10 align-items-center grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 sm:gap-y-14 lg:max-w-4xl lg:grid-cols-5">
                <p className="text-white">Partnered Globally</p>
                <img
                    className="col-span-2 h-15 w-full object-contain lg:col-span-1"
                    src={photo3}
                />
                <img
                    className="col-span-2 h-15 w-full object-contain lg:col-span-1"
                    src={photo3}
                />
                <img
                    className="col-span-2 h-15 w-full object-contain lg:col-span-1"
                    src={photo3}
                />
                <img
                    className="col-span-2 h-15 w-full object-contain lg:col-span-1"
                    src={photo3}
                />

            </div>
        </div>

    )
}